import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en, zh } from '@assets/locales';
import { updateLanguage } from '@services/user/action';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en_US: {
        translation: en,
    },
    zh_TW: {
        translation: zh,
    },
};

export const SupportLanguage = Object.freeze({
    en_US: 'en_US',
    zh_TW: 'zh_TW',
});

export function changeLanguage(language: string, dispatch?: Function) {
    if (!language) return i18n.changeLanguage(SupportLanguage.en_US);

    if (language === i18n.language) return;

    if (!SupportLanguage[language])
        throw new Error(`Unsupported language ${language}`);

    if (dispatch) dispatch(updateLanguage(language));

    i18n.changeLanguage(language);
}

export function translate(value: string): string {
    return i18n.getResource(i18n.language, 'translation', value) || value;
}

export function isKeyExists(key: string): boolean {
    return i18n.exists(key);
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: SupportLanguage.en_US,

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
